import React from "react";
import get from "lodash/get";

import Multimedia from "@stadium/ui/src/components/multimedia/multimedia";
import { BrowserDocumentInteractive } from "@stadium/ui/src/components/browser/document-interactive";

import PrismicImgix from "@sendmagic/prismic-nextjs/src/components/Imgix";
import PrismicLinkTag from "@sendmagic/prismic-nextjs/src/components/LinkTag";

import { textResolver } from "@sendmagic/prismic-nextjs/src/constants/text-resolver";
import { checkContentPresence } from "@sendmagic/prismic-nextjs/src/helpers/prismic";
import VideoPlayer from "@sendmagic/prismic-nextjs/src/components/VideoPlayer";

//  // import "./styles/HeaderBanner.module.scss";

const BannerLink = ({ url_text, url: { url, target }, className = "" }) => (
  <div className="col-lg-6 mt-2 mt-2xl-2 mx-auto mx-md-0">
    <PrismicLinkTag urlText={url_text} url={url} target={target} className={className} />
  </div>
);

const Banner = ({ doc, StartOrderBtn }) => {
  const {
    title,
    title_color,
    description,
    description_color,
    start_an_order_button_flag,
    align_image_to_left,
    image,
    video,
    video_embed,
    video_embed_height,
    video_embed_width,
    internal_link_id,
    background_color,
    background_video,
    background_video_mobile,
    header_text,
    stretch_to_max_height = false,
    footer_heading,
    footer_heading_color,
    footer_description,
    opacity,
    vimeo_video_embed,
  } = doc.primary;

  const customClass = stretch_to_max_height ? "full-image-block" : "";
  const customClassVideo = video?.url ? "header-video-banner" : "";
  const useHeight = video_embed_height || "100%";
  const useWidth = video_embed_width || "100%";
  const alignImageClass = align_image_to_left ? "flex-row-reverse" : "";

  return (
    <div
      className={`position-relative banner header-banner prismic-slice header-banner-slice ${customClass} ${customClassVideo}`}
      style={{ background: background_color }}
    >
      {internal_link_id && (
        <span id={internal_link_id} className="scroll-point position-absolute d-block" />
      )}

      <div
        className="header-banner-video-bg d-none d-sm-block d-md-none"
        style={{ opacity: opacity / 10 }}
      >
        {background_video_mobile?.url &&
          (background_video_mobile.link_type === "Web" ? (
            <Multimedia
              type="iframe"
              src={background_video_mobile.url}
              className="header-bg-video"
              width="100%"
              height="100%"
              frameborder="0"
              loading="lazy"
              isNextImage={false}
            />
          ) : (
            <Multimedia
              type="video"
              src={background_video_mobile.url}
              lazy
              className="header-bg-video"
              autoPlay
              loop
              isNextImage={false}
            />
          ))}
      </div>

      <div
        className="header-banner-video-bg d-sm-none d-md-block"
        style={{ opacity: opacity / 10 }}
      >
        {background_video?.url &&
          (background_video.link_type === "Web" ? (
            <Multimedia
              type="iframe"
              src={background_video.url}
              className="header-bg-video"
              width="100%"
              height="100%"
              frameborder="0"
              loading="lazy"
            />
          ) : (
            <Multimedia
              type="video"
              src={background_video.url}
              lazy
              className="header-bg-video"
              autoPlay
              loop
            />
          ))}
      </div>

      <div className={`row no-gutters header-banner-slice-row container-width ${alignImageClass}`}>
        <div className="col-md-6 order-1 order-md-0">
          <div className="text-center text-md-left header-banner-content-block">
            {checkContentPresence(header_text) && (
              <div className="mt-4 mt-md-0 mb-3 mb-2xl-3 sns-h4 text-grey-97 banner-header-text">
                {textResolver(header_text)}
              </div>
            )}
            <div
              className="mt-3 mt-md-0 sns-h1 text-theme-primary banner-header-title"
              style={{ color: title_color }}
            >
              {textResolver(title)}
            </div>
            <div
              className="sns-h5 my-3 my-2xl-3 banner-description-block"
              style={{ color: description_color }}
            >
              {textResolver(description)}
            </div>
            <div className="start-an-order-home-btn row">
              {start_an_order_button_flag && StartOrderBtn && (
                <div className="col-lg-6 mt-2 mt-2xl-2 mx-auto mx-md-0">
                  <StartOrderBtn className="button button-program-green btn btn-block font-weight-bold">
                    Send A Treat
                  </StartOrderBtn>
                </div>
              )}
              {get(doc, "items", []).map((link, idx) => (
                <BannerLink
                  {...link}
                  key={`option-${idx}`}
                  className={`button button-program-${
                    link?.transparent ? "outline-" : ""
                  }green font-weight-bold btn btn-block`}
                />
              ))}
            </div>
            {checkContentPresence(footer_heading) && (
              <div className="mt-4 mt-xl-5">
                <div
                  className="mt-3 mt-lg-0 sns-h4 text-theme-primary"
                  style={{ color: footer_heading_color }}
                >
                  {textResolver(footer_heading)}
                </div>
                {checkContentPresence(footer_description) && (
                  <div
                    className="sns-h5 my-2 my-2xl-3 banner-description-block"
                    style={{ color: description_color }}
                  >
                    {textResolver(footer_description)}
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
        <div className="col-md-6 d-flex align-items-center overflow-hidden header-media-container">
          <div className="header-banner-image-holder">
            {video?.url ? (
              video.link_type === "Web" ? (
                <Multimedia
                  type="iframe"
                  src={video.url}
                  className="header-bg-video"
                  width="100%"
                  height="100%"
                  frameborder="0"
                  loading="lazy"
                  muted
                />
              ) : (
                <Multimedia
                  type="video"
                  src={video.url}
                  lazy
                  className="header-bg-video"
                  autoPlay
                  loop
                  muted
                />
              )
            ) : (
              image?.url &&
              !vimeo_video_embed?.embed_url && (
                <PrismicImgix
                  className="header-banner-image"
                  src={image.url}
                  alt={image.alt}
                  desktop="750px"
                  mobile="375px"
                  tablet="400px"
                  largeDisplay="1200px"
                  lazySizesEnabled={false}
                />
              )
            )}
          </div>
          <BrowserDocumentInteractive>
            <div className="header-banner-video-holder">
              <VideoPlayer
                videoEmbed={video_embed}
                vimeoVideoEmbed={vimeo_video_embed}
                useHeight={useHeight}
                useWidth={useWidth}
                vimeoThumbnail={image?.url}
              />
            </div>
          </BrowserDocumentInteractive>
        </div>
      </div>
    </div>
  );
};

export default Banner;
